import { render, staticRenderFns } from "./contract-trans.vue?vue&type=template&id=4d98798d&scoped=true"
import script from "./contract-trans.vue?vue&type=script&lang=js"
export * from "./contract-trans.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=4d98798d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d98798d",
  null
  
)

export default component.exports